<template>
  <div id="app">
    <div class="appIndex">
      <Header/>
      <router-view/>
      <Footer/>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Common/Header.vue";
import Footer from "@/components/Common/Footer.vue";
export default {
  name: "App",
  components: {
    Header,
    Footer
  }
};
</script>
<style lang="stylus" scoped>
#app {
  background: repeating-linear-gradient(
    0deg,
    #b2edfe,
    #6aaafe
  );  
}

.appIndex { 
  background: url('./assets/index_line.png');
}
</style>




// WEBPACK FOOTER //
// src/App.vue